/**
 * Generate URL with query params
 * @param path Base URL path
 * @param params Object of query params
 * @returns URL with query params
 * @example
 * generateUrlWithParams('/path', { key: 'value' }) => '/path?key=value'
 */
const generateUrlWithParams = (path: string, params: Record<string, string>): string => {
  const url = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.set(key, value);
    }
  });

  return params && Object.keys(params).length > 0 ? `${path}?${url.toString()}` : path;
};

export default generateUrlWithParams;
